import { ComponentPropsWithRef } from 'react';
import { Controller } from 'react-hook-form';

import { InputCheckbox, InputCheckboxItem } from '../input/input-checkbox';

type InputCheckboxControllerProps<T> = Omit<
  ComponentPropsWithRef<typeof InputCheckbox>,
  'name' | 'defaultValue' | 'options' | 'onChange' | 'onBlur'
> & {
  name: string;
  defaultValue?: T[] | T;
  options?: InputCheckboxItem<T>[];
  onChange?: (e: T[] | (T | null)) => void;
  onBlur?: () => void;
};

export function InputCheckboxController<T>(
  props: InputCheckboxControllerProps<T>
) {
  const { defaultValue, onChange, onBlur, ...defaultProps } = props;

  return (
    <Controller
      render={({
        field: {
          onChange: onControllerChange,
          onBlur: onControllerBlur,
          value,
        },
        fieldState: { error },
      }) => (
        <InputCheckbox<T>
          {...defaultProps}
          onChange={e => {
            onControllerChange(e);
            onControllerBlur();

            onChange?.(e);
          }}
          value={value ?? ''}
          error={error?.message}
        />
      )}
      name={props.name}
      defaultValue={defaultValue ?? ''}
    />
  );
}
